import React, { ChangeEvent, FC } from 'react';

import BaseTextField from '../baseTextField';
import { ValueFieldProps } from '@sitecore-jss/sitecore-jss-react-forms/types';

const CustomNumberField: FC<ValueFieldProps> = (props) => {
  const handleOnInput = (event: ChangeEvent<HTMLInputElement>): void => {
    if (event.target.value.lastIndexOf('+') > 0 || event.target.value.lastIndexOf('-') > 0) {
      event.target.value = event.target.value.slice(0, -1);
      return;
    }

    event.target.value = event.target.value.replace(/[^0-9.,+-]/g, '');
  };

  const inputAttributes = {
    onInput: handleOnInput,
  };

  return <BaseTextField type="text" inputAttributes={inputAttributes} {...props} />;
};

export default CustomNumberField;
